// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for history
export const historyState = $state({
    actions: [],
    position: 0
});

// Function to undo an action
export function undo() {
    if (historyState.position > 1) {
        historyState.position--;
    }
}

// Function to redo an action
export function redo() {
    if (historyState.position < historyState.actions.length) {
        historyState.position++;
    }
}

// Function to insert a new action into history
export function insertHistoryAction(action) {
    /* Remove any undo actions from the history stack */
    if (historyState.position < historyState.actions.length) {
        historyState.actions = historyState.actions.slice(0, historyState.position);
    }

    /* Limit stack to 10+1 undos */
    historyState.actions = [...historyState.actions.splice(-10), action];
    historyState.position = historyState.actions.length;
}

// Function to reset the history
export function resetHistory() {
    historyState.actions = [];
    historyState.position = 0;
}